import React from 'react';
import type { CategoryState } from '@atlassian/jira-business-categories/src/common/types.tsx';
import CategoryTag from '@atlassian/jira-business-categories/src/ui/category-form/category-tag/index.tsx';
import { TagListWrapper } from '@atlassian/jira-business-fields/src/common/ui/tag-list-wrapper/index.tsx';

export type CategoryCellContentProps = {
	isEditable: boolean;
	categoryState: CategoryState | null;
	onClick?: () => void;
};

export const CategoryCellContent = ({
	categoryState,
	isEditable,
	onClick,
}: CategoryCellContentProps) => {
	if (!categoryState) {
		return (
			<TagListWrapper
				onClick={onClick}
				isEditable={isEditable}
				data-testid="business-list.ui.list-view.category-cell.category-cell-content.no-category-wrapper"
			/>
		);
	}

	return (
		<TagListWrapper
			onClick={onClick}
			isEditable={isEditable}
			data-testid="business-list.ui.list-view.category-cell.category-cell-content.category-wrapper"
		>
			<CategoryTag
				categoryColor={categoryState.color?.toString() ?? null}
				categoryName={categoryState.value ?? ''}
			/>
		</TagListWrapper>
	);
};
